import { api } from "./api";
import { User } from "@/types/user";
import logger from "../utils/logger";

export const updateUserKey = async (userId: string, key: string): Promise<User> => {
  try {
    const response = await api.put(`/user/${userId}/key`, { key });
    return response.data;
  } catch (error) {
    logger.error("Login error:", undefined, error);
    throw error;
  }
};
